// https://stackoverflow.com/questions/38241480/detect-macos-ios-windows-android-and-linux-os-with-js
type OS = 'Mac OS' | 'iOS' | 'iPadOS' | 'Windows' | 'Android' | 'Linux';
export function getOS(): OS | null {
  if (typeof window === 'undefined') {
    return null;
  }
  const navigator = window.navigator as any;
  const userAgent = navigator.userAgent,
    platform =
      'userAgentData' in navigator
        ? navigator.userAgentData?.platform
        : navigator.platform,
    macosPlatforms = ['macOS', 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iPadOsPlatforms = ['iPad'],
    iosPlatforms = ['iPhone', 'iPod'];
  let os: OS | null = null;

  // https://stackoverflow.com/questions/56578799/tell-ipados-from-macos-on-the-web
  const isIPad =
    iPadOsPlatforms.indexOf(platform) !== -1 ||
    (navigator.userAgent.match(/Mac/) &&
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2);

  if (isIPad) {
    return 'iPadOS';
  } else if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (/Linux/.test(platform)) {
    os = 'Linux';
  }

  return os;
}
